import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { version as appVersion } from '../../../package.json';
import { AppSettings } from '../../config/config';

export interface ChatStaffListItem {
  staffId: string;
  staffName: string;
  designation: string;
  staffImage: string;
  message: string | null;
  fromUserId: string;
  IsRead: 0 | 1;
  timeStamp: string;
  unreadCount: number;
  isTyping: boolean;
  fkChatGroupId: string | null;
}

export interface ChatMessageItem {
  messageId: string | null;
  message: string;
  fromUserId: string;
  timeStamp: string;
  uid: string;
  IsRead: 0 | 1;
}

// Owns the single persistent Socket.IO connection shared by the chat
// staff-list screen and conversation screen — same architecture as
// StaffChatSocketService (staff<->student), mirrored here for
// parent<->staff. Socket.IO event-driven, not REST/Firebase — auth reuses
// the parent's own session token (localStorage authToken), sent as a
// custom header on the polling handshake, per the API reference this was
// built from. One connection is opened per visit to the chat feature and
// torn down on exit.
@Injectable({ providedIn: 'root' })
export class ParentChatSocketService {
  private socket: Socket | null = null;

  connect(): Socket {
    if (this.socket) { return this.socket; }
    const authToken = this.getAuthToken();
    this.socket = io(AppSettings.API_ENDPOINT_STAFF_BASE, {
      transportOptions: {
        polling: {
          extraHeaders: {
            authtoken: authToken || '',
            lang: 'en',
            appversion: appVersion,
            mobileos: 'web',
            'idempotency-key': crypto.randomUUID(),
          },
        },
      },
    });
    return this.socket;
  }

  getSocket(): Socket | null {
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  private getAuthToken(): string {
    const raw = localStorage.getItem('authToken');
    if (!raw) { return ''; }
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  }
}
